import type { SVGProps } from "react";
// generated from Upload.svg — do not edit manually
// prettier-ignore
export default function Upload(props: SVGProps<SVGSVGElement>) {
  return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}><path d="M 21 22 H 3 M 18 9 L 12 3 M 12 3 L 6 9 M 12 3 V 17" stroke="currentColor" strokeWidth="1.5"/></svg>);
}
